module.exports = __webpack_public_path__ + "img/studentWallets.cbc99471.svg";